import {
  Button,
  Grid,
  KeyboardArrowDownIcon,
  KeyboardArrowUpIcon,
  makeStyles,
  Theme,
  Typography,
} from '@freighthub/silhouette-core'
import { zip } from 'lodash-es'
import { FC, useReducer } from 'react'
import { useI18n } from 'utils/localisation'

type CollapseTableProps = {
  content: string[][]
}

const useStyles = makeStyles<Theme>((theme) => ({
  content: {
    marginTop: theme.spacing(1),
  },
  column: {
    width: 'auto',
    marginRight: theme.spacing(1),
  },
  button: {
    padding: theme.spacing(1, 0),
  },
}))

const MAX_VISIBLE_ROWS = 3

export const CollapseTable: FC<CollapseTableProps> = ({ content }) => {
  const classes = useStyles()
  const { translate } = useI18n()

  const [isExpanded, toggleExpansion] = useReducer((wasExpanded: boolean) => !wasExpanded, false)
  const isExpandable = content.length > MAX_VISIBLE_ROWS + 1 // rows + 1 header
  const shouldShowRow = (rowIndex) => rowIndex < MAX_VISIBLE_ROWS || isExpanded

  const columns = zip(...content)

  return (
    <>
      <Grid container className={classes.content}>
        {columns.map(([header, ...values]) => (
          <Grid container direction="column" spacing={1} key={header} className={classes.column}>
            <Grid>
              <Typography className={classes.header}>
                {/* @ts-expect-error TS(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message */}
                <i>{translate(header)}</i>
              </Typography>
            </Grid>
            {values.map(
              (value, index) =>
                shouldShowRow(index) && (
                  <Grid key={index}>
                    {/* @ts-expect-error TS(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message */}
                    <Typography>{translate(value)}</Typography>
                  </Grid>
                )
            )}
          </Grid>
        ))}
      </Grid>
      {isExpandable && (
        <Button
          className={classes.button}
          onClick={toggleExpansion}
          startIcon={isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        >
          {isExpanded ? translate('required_actions-show_less') : translate('required_actions-show_more')}
        </Button>
      )}
    </>
  )
}
